import Dialog from '@mui/material/Dialog'
import { forwardRef, useImperativeHandle, useEffect, useState } from 'react'

import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { useForm } from 'react-hook-form'
import { makePostRequest, makePutRequest } from 'utils/api'
import { UTILISATION } from 'utils/constants'
import { sanatizeServerError } from 'utils/helpers'
import urls from 'utils/urls'
import { GeneralInformationForm } from './GeneralInformationForm'
import { UtilisationForm } from './UtilisationForm'
import { makeGetRequest } from 'utils/api'
import { ResetTv } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { parseInt } from 'lodash'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ImmobilierFormDialog = forwardRef((props, ref) => {
  const {
    handleUpdateList,
    selectedRows,
    setSelectedRows,
    contacts,
    documents,
    setDocuments,
    superficies,
    nombreHabitant,
    typeChauffeEau,
    Norme,
    typeDeChauffage,
    typeDeBien,
    energyClassification,
    getPays,
  } = props
  let w_logement = localStorage.getItem('w-logement')
  const navigate = useNavigate()
  const [activeDocument, setActiveDocument] = useState({})
  const [open, setOpen] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  const [utilisationType, setUtilisationType] = useState(1)
  const [finalPayload, setFinalPayload] = useState({})
  const [step, setStep] = useState(0)

  const [imageId, setImageId] = useState([])
  const [files, setFiles] = useState(null)
  const {
    reset,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nom: '',
      pays: '',
      utilisation: '',
      pieces: '',
      supercifie: '',
      // consumption: '',
      // emission_CO2: '',
      energy_classification: '',
      type_de_bien: '',
    },
  })

  useEffect(() => {
    // fetchImmoFootPrint1()
  }, [])

  const handleClickOpen = (edit) => {
    setActiveDocument({})
    if (edit) {
      const activeObj = documents.results.find((v) => v.id === selectedRows[0])
      setActiveDocument({ ...activeObj })
    }
    setOpen(true)
  }

  const handleClose = (v = false) => {
    if (v === 1) setStep(1)
    if (v === 0) setStep(0)
    if (v === false) {
      setOpen(false)
      if (w_logement) {
        navigate('/')
      }
    }
  }
  useImperativeHandle(ref, () => ({
    handleClickOpen,
    handleClose,
  }))

  const upload_immobilier_picture = (id) => {
    if (files) {
      const filearr = Array.from(files)
      filearr.forEach(async (f) => {
        let formData = new FormData()
        let url = '/api/domicile/upload-immobilier-picture/' //p
        if (f != null) formData.append('image', f)
        formData.append('id', id)
        const response = await makePostRequest(
          url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
          true,
        )
        if (response.status === 200) {
        }
      })
    }
  }

  const handleSubmitData = async (data) => {
    const payload = {
      ...finalPayload,
    }
    // delete payload.picture
    // const formData = new FormData()
    // if (files != null) formData.append('Lien', files)
    const utilistation = UTILISATION.find((v) => v.value === utilisationType)
    payload[utilistation.id] = data
    // if(payload.date_of_sale === '')
    //   delete payload.date_of_sale

    let response = null
    let url = urls.crudImmobilier
    if (activeDocument.utilisation) {
      url = urls.crudImmobilier + activeDocument.id + '/' //p
      response = await makePutRequest(url, payload, {}, true)
    } else {
      response = await makePostRequest(url, payload, {}, true)
    }
    if (response.status === 201 || response.status === 200) {
      upload_immobilier_picture(response.data.id)
      setStep(0)
      setFiles(null)

      if (activeDocument.utilisation) {
        let id = response.data.id
        const filtereddocuments = documents.results.filter((v) => v.id !== id)
        const updateddocuments = [...filtereddocuments, { ...response.data }].sort((a, b) =>
          a.id > b.id ? 1 : -1,
        )

        setDocuments((documents) => ({
          ...documents,
          results: updateddocuments,
        }))
      } else {
        setDocuments((documents) => ({
          ...documents,
          results: [...documents.results, response.data],
          count: documents.count + 1,
        }))
      }
      if (w_logement) {
        let pr_count = localStorage.getItem('wl_count')
        if (pr_count) {
          localStorage.setItem('wl_count', parseInt(pr_count) + 1)
          localStorage.setItem(
            't_message',
            `Vous avez ajouté ${parseInt(pr_count) + 1} biens immobiliers.`,
          )
        } else {
          localStorage.setItem('wl_count', 1)
          localStorage.setItem('t_message', 'Vous avez ajouté 1 bien immobilier.')
        }
        localStorage.setItem('wl_done', true)
      }
      // setActiveDocument({})
      // setSelectedRows([])
    }
    handleClose(false)

    // setOperations(operations => ({
    //   ...operations,
    //   results: [...operations.results, response.data],
    //   count: operations.count + 1,
    // }))
    // if ( activeDocument.utilisation )
    // {
    //   response = await makePutRequest( urls.crudImmobilier + activeDocument.id + '/', payload, {} )
    // }
    // if ( response.status === 201 || response.status === 200 )
    // {
    //   handleUpdateList( response.data, activeDocument )
    //   await makePostRequest( "/api/domicile/immobilier-create-cat/", payload, {} )
    //   handleClose()
    //   setStep( 0 )
    // } else
    // {
    //   const error = sanatizeServerError( response.data )
    //   const {
    //     nom,
    //     pays,
    //     pieces,
    //     superficie,
    //     // consumption,
    //     // emission_CO2,
    //     energy_classification,
    //     type_de_bien,
    //     utilisation,
    //   } = error
    //   if (
    //     nom ||
    //     pays ||
    //     pieces ||
    //     superficie ||
    //     // consumption ||
    //     // emission_CO2 ||
    //     energy_classification ||
    //     type_de_bien ||
    //     utilisation
    //   )
    //   {
    //     setStep( 0 )
    //   } else
    //   {
    //     setStep( 1 )
    //   }
    //   setFormErrors( error )
    // }
  }

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {activeDocument.utilisation ? (
          <DialogTitle sx={{ backgroundColor: '#202020' }}>Modifi Immobilier</DialogTitle>
        ) : (
          <DialogTitle sx={{ backgroundColor: '#202020' }}>Create Immobilier</DialogTitle>
        )}

        {step === 0 ? (
          <GeneralInformationForm
            setStep={setStep}
            formErrors={formErrors}
            setUtilisationType={setUtilisationType}
            setFinalPayload={setFinalPayload}
            handleClose={handleClose}
            activeDocument={activeDocument}
            energyClassification={energyClassification}
            typeDeBien={typeDeBien}
            superficie={superficies}
            setFiles={setFiles}
            getPays={getPays}
            typeDeChauffage={typeDeChauffage}
            // imageId={imageId}
          />
        ) : (
          <UtilisationForm
            utilisationType={utilisationType}
            handleSubmitData={handleSubmitData}
            formErrors={formErrors}
            handleClose={handleClose}
            activeDocument={activeDocument}
            typeDeChauffage={typeDeChauffage}
            Norme={Norme}
            typeChauffeEau={typeChauffeEau}
            nombreHabitant={nombreHabitant}
            contacts={contacts}
          />
        )}
      </Dialog>
    </>
  )
})

export default ImmobilierFormDialog
